enum Paths {
  PowerBiReport = "/compliance-dashboard",
}

export default Paths;
